import { render, staticRenderFns } from "./ArticleOverridesNotice.vue?vue&type=template&id=588edd51&scoped=true&lang=pug&"
import script from "./ArticleOverridesNotice.vue?vue&type=script&lang=js&"
export * from "./ArticleOverridesNotice.vue?vue&type=script&lang=js&"
import style0 from "./ArticleOverridesNotice.vue?vue&type=style&index=0&id=588edd51&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588edd51",
  null
  
)

/* custom blocks */
import block0 from "./ArticleOverridesNotice.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports